<template>
  <v-form @submit.prevent>
    <v-row>
      <v-col cols="12" class="pb-1">
        <single-date-picker
          ref="datePicker"
          :label="$t('date')"
          :item-date="date"
          :max="maxDate"
          @update:date="$emit('apply-date', $event)"
        >
        </single-date-picker>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapState } from "vuex";
import { addDays } from "date-fns";
import SingleDatePicker from "@/components/formFields/SingleDatePicker";

export default {
  name: "ReportsDatePickerFilter",
  components: {
    SingleDatePicker,
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    initialDate: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      date: null,
      datePicker: false,
    };
  },
  computed: {
    maxDate() {
      return addDays(new Date(), -6).toISOString();
    },
    ...mapState(["currentHotel"]),
    ...mapState("language", ["language"]),
  },
  watch: {
    showDialog: {
      immediate: true,
      handler(val) {
        if (val) {
          this.date = JSON.parse(JSON.stringify(this.initialDate));
          setTimeout(() => {
            this.$refs.datePicker.$refs.datePickerTextField.focus();
            this.$refs.datePicker.show = true;
          }, 300);
        }
      },
    },
  },
};
</script>
